import { useState } from 'react';
import { useTheme } from '../context/ThemeContext';
import './ThemeToggle.css';

function ThemeToggle() {
  const { theme, setTheme } = useTheme();
  const [isOpen, setIsOpen] = useState(false);

  const themes = [
    { name: 'blue', label: 'Blue', icon: '🔵' },
    { name: 'light', label: 'Light', icon: '☀️' },
    { name: 'matrix', label: 'Matrix', icon: '🌙' }
  ];

  const currentTheme = themes.find(t => t.name === theme);

  const handleThemeSelect = (themeName) => {
    setTheme(themeName);
    setIsOpen(false);
  };

  return (
    <div className="theme-toggle-container">
      <button
        className="theme-toggle"
        onClick={() => setIsOpen(!isOpen)}
        aria-label="Select theme"
      >
        <span className="theme-icon">{currentTheme.icon}</span>
        <span className="theme-text">{currentTheme.label}</span>
        <span className="dropdown-arrow">{isOpen ? '▲' : '▼'}</span>
      </button>
      {isOpen && (
        <div className="theme-dropdown">
          {themes.map((t) => (
            <button
              key={t.name}
              className={`theme-option ${t.name === theme ? 'active' : ''}`}
              onClick={() => handleThemeSelect(t.name)}
            >
              <span className="theme-icon">{t.icon}</span>
              <span className="theme-text">{t.label}</span>
            </button>
          ))}
        </div>
      )}
    </div>
  );
}

export default ThemeToggle;
